<com-web-dialog [dialogTitle]="title" [icon]="icon" [isDraggable]="true">
    <p>{{ message }}</p>

    <div footer class="flex flex-col">
        <div class="flex grow w-full justify-end">
            <com-web-button
                [buttonType]="ButtonType.Cancel"
                [label]="cancelText"
                (click)="cancel()"></com-web-button>

            <com-web-button
                [buttonStyle]="ButtonStyle.Primary"
                [label]="confirmText"
                (click)="confirm()"></com-web-button>
        </div>
    </div>
</com-web-dialog>
